import type { Issue } from '../lib/stats/analysis'

/**
 * 品質の指摘。
 *
 * 判定より前に置き、統計以前の理由で結果が信用できない状態を先に伝える。
 * 比率のタブと平均のタブで同じ見え方にするため共通化している。
 */
export function IssueList({ issues }: { issues: readonly Issue[] }) {
  if (issues.length === 0) return null
  return (
    <div className="issues">
      {issues.map((issue, index) => (
        <IssueRow key={`${issue.title}-${index}`} issue={issue} />
      ))}
    </div>
  )
}

function IssueRow({ issue }: { issue: Issue }) {
  const icon =
    issue.level === 'error' ? '!' : issue.level === 'warning' ? '▲' : 'i'
  return (
    <div className={`issue issue-${issue.level}`}>
      <span className="issue-icon" aria-hidden="true">
        {icon}
      </span>
      <div>
        <div className="issue-title">{issue.title}</div>
        <div className="issue-detail">{issue.detail}</div>
      </div>
    </div>
  )
}
